import { a as _slicedToArray } from './_rollupPluginBabelHelpers-e71b1aad.js';
import React__default, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import 'react-dates/initialize';
import moment$1 from 'moment';
import { a as createCommonjsModule, c as commonjsGlobal, u as unwrapExports } from './_commonjsHelpers-17042db9.js';
import { D as DayPickerRangeControllerWrapper, a as DateRangePickerConstants } from './DayPickerRangeControllerWrapper-189ca52a.js';
import { i as intlShape, u as dayPricesShape, n as nodeOrStringProp, l as nodeOrStringOrFuncProp } from './PropTypes-e1e509ba.js';

var momentRange = createCommonjsModule(function (module, exports) {
!function(t,e){module.exports=e(moment$1);}(commonjsGlobal,function(t){return function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,e),o.l=!0,o.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r});},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=3)}([function(t,e,n){var r=n(5)();t.exports=function(t){return t!==r&&null!==t};},function(t,e,n){t.exports=n(18)()?Symbol:n(20);},function(e,n){e.exports=t;},function(t,e,n){function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function u(t){return t.range=function(e,n){var r=this;return "string"==typeof e&&y.hasOwnProperty(e)?new h(t(r).startOf(e),t(r).endOf(e)):new h(e,n)},t.rangeFromInterval=function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:t();if(t.isMoment(r)||(r=t(r)),!r.isValid())throw new Error("Invalid date.");var o=r.clone().add(n,e),i=[];return i.push(t.min(r,o)),i.push(t.max(r,o)),new h(i)},t.rangeFromISOString=function(e){var n=a(e),r=t.parseZone(n[0]),o=t.parseZone(n[1]);return new h(r,o)},t.parseZoneRange=t.rangeFromISOString,t.fn.range=t.range,t.range.constructor=h,t.isRange=function(t){return t instanceof h},t.fn.within=function(t){return t.contains(this.toDate())},t}function a(t){return t.split("/")}Object.defineProperty(e,"__esModule",{value:!0}),e.DateRange=void 0;var s=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var u,a=t[Symbol.iterator]();!(r=(u=a.next()).done)&&(n.push(u.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t;}finally{try{!r&&a.return&&a.return();}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},f=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}();e.extendMoment=u;var l=n(2),v=r(l),d=n(1),p=r(d),y={year:!0,quarter:!0,month:!0,week:!0,day:!0,hour:!0,minute:!0,second:!0},h=e.DateRange=function(){function t(e,n){i(this,t);var r=e,o=n;if(1===arguments.length||void 0===n)if("object"===(void 0===e?"undefined":c(e))&&2===e.length){var u=s(e,2);r=u[0],o=u[1];}else if("string"==typeof e){var f=a(e),l=s(f,2);r=l[0],o=l[1];}this.start=r||0===r?(0, v.default)(r):(0, v.default)(-864e13),this.end=o||0===o?(0, v.default)(o):(0, v.default)(864e13);}return f(t,[{key:"adjacent",value:function(t){var e=this.start.isSame(t.end),n=this.end.isSame(t.start);return e&&t.start.valueOf()<=this.start.valueOf()||n&&t.end.valueOf()>=this.end.valueOf()}},{key:"add",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{adjacent:!1};return this.overlaps(t,e)?new this.constructor(v.default.min(this.start,t.start),v.default.max(this.end,t.end)):null}},{key:"by",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{excludeEnd:!1,step:1},n=this;return o({},p.default.iterator,function(){var r=e.step||1,o=Math.abs(n.start.diff(n.end,t))/r,i=e.excludeEnd||!1,u=0;return e.hasOwnProperty("exclusive")&&(i=e.exclusive),{next:function(){var e=n.start.clone().add(u*r,t),a=i?!(u<o):!(u<=o);return u++,{done:a,value:a?void 0:e}}}})}},{key:"byRange",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{excludeEnd:!1,step:1},n=this,r=e.step||1,i=this.valueOf()/t.valueOf()/r,u=Math.floor(i),a=e.excludeEnd||!1,s=0;return e.hasOwnProperty("exclusive")&&(a=e.exclusive),o({},p.default.iterator,function(){return u===1/0?{done:!0}:{next:function(){var e=(0, v.default)(n.start.valueOf()+t.valueOf()*s*r),o=u===i&&a?!(s<u):!(s<=u);return s++,{done:o,value:o?void 0:e}}}})}},{key:"center",value:function(){var t=this.start.valueOf()+this.diff()/2;return (0, v.default)(t)}},{key:"clone",value:function(){return new this.constructor(this.start.clone(),this.end.clone())}},{key:"contains",value:function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{excludeStart:!1,excludeEnd:!1},r=this.start.valueOf(),o=this.end.valueOf(),i=e.valueOf(),u=e.valueOf(),a=n.excludeStart||!1,s=n.excludeEnd||!1;n.hasOwnProperty("exclusive")&&(a=s=n.exclusive),e instanceof t&&(i=e.start.valueOf(),u=e.end.valueOf());var c=r<i||r<=i&&!a,f=o>u||o>=u&&!s;return c&&f}},{key:"diff",value:function(t,e){return this.end.diff(this.start,t,e)}},{key:"duration",value:function(t,e){return this.diff(t,e)}},{key:"intersect",value:function(t){var e=this.start.valueOf(),n=this.end.valueOf(),r=t.start.valueOf(),o=t.end.valueOf(),i=e==n,u=r==o;if(i){var a=e;if(a==r||a==o)return null;if(a>r&&a<o)return this.clone()}else if(u){var s=r;if(s==e||s==n)return null;if(s>e&&s<n)return new this.constructor(s,s)}return e<=r&&r<n&&n<o?new this.constructor(r,n):r<e&&e<o&&o<=n?new this.constructor(e,o):r<e&&e<=n&&n<o?this.clone():e<=r&&r<=o&&o<=n?new this.constructor(r,o):null}},{key:"isEqual",value:function(t){return this.start.isSame(t.start)&&this.end.isSame(t.end)}},{key:"isSame",value:function(t){return this.isEqual(t)}},{key:"overlaps",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{adjacent:!1},n=null!==this.intersect(t);return e.adjacent&&!n?this.adjacent(t):n}},{key:"reverseBy",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{excludeStart:!1,step:1},n=this;return o({},p.default.iterator,function(){var r=e.step||1,o=Math.abs(n.start.diff(n.end,t))/r,i=e.excludeStart||!1,u=0;return e.hasOwnProperty("exclusive")&&(i=e.exclusive),{next:function(){var e=n.end.clone().subtract(u*r,t),a=i?!(u<o):!(u<=o);return u++,{done:a,value:a?void 0:e}}}})}},{key:"reverseByRange",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{excludeStart:!1,step:1},n=this,r=e.step||1,i=this.valueOf()/t.valueOf()/r,u=Math.floor(i),a=e.excludeStart||!1,s=0;return e.hasOwnProperty("exclusive")&&(a=e.exclusive),o({},p.default.iterator,function(){return u===1/0?{done:!0}:{next:function(){var e=(0, v.default)(n.end.valueOf()-t.valueOf()*s*r),o=u===i&&a?!(s<u):!(s<=u);return s++,{done:o,value:o?void 0:e}}}})}},{key:"snapTo",value:function(t){var e=this.clone();return e.start.isSame((0, v.default)(-864e13))||(e.start=e.start.startOf(t)),e.end.isSame((0, v.default)(864e13))||(e.end=e.end.endOf(t)),e}},{key:"subtract",value:function(t){var e=this.start.valueOf(),n=this.end.valueOf(),r=t.start.valueOf(),o=t.end.valueOf();return null===this.intersect(t)?[this]:r<=e&&e<n&&n<=o?[]:r<=e&&e<o&&o<n?[new this.constructor(o,n)]:e<r&&r<n&&n<=o?[new this.constructor(e,r)]:e<r&&r<o&&o<n?[new this.constructor(e,r),new this.constructor(o,n)]:e<r&&r<n&&o<n?[new this.constructor(e,r),new this.constructor(r,n)]:[]}},{key:"toDate",value:function(){return [this.start.toDate(),this.end.toDate()]}},{key:"toString",value:function(){return this.start.format()+"/"+this.end.format()}},{key:"valueOf",value:function(){return this.end.valueOf()-this.start.valueOf()}}]),t}();},function(t,e,n){var r,o=n(6),i=n(13),u=n(9),a=n(15);r=t.exports=function(t,e){var n,r,u,s,c;return arguments.length<2||"string"!=typeof t?(s=e,e=t,t=null):s=arguments[2],null==t?(n=u=!0,r=!1):(n=a.call(t,"c"),r=a.call(t,"e"),u=a.call(t,"w")),c={value:e,configurable:n,enumerable:r,writable:u},s?o(i(s),c):c},r.gs=function(t,e,n){var r,s,c,f;return "string"!=typeof t?(c=n,n=e,e=t,t=null):c=arguments[3],null==e?e=void 0:u(e)?null==n?n=void 0:u(n)||(c=n,n=void 0):(c=e,e=n=void 0),null==t?(r=!0,s=!1):(r=a.call(t,"c"),s=a.call(t,"e")),f={get:e,set:n,configurable:r,enumerable:s},c?o(i(c),f):f};},function(t,e,n){t.exports=function(){};},function(t,e,n){t.exports=n(7)()?Object.assign:n(8);},function(t,e,n){t.exports=function(){var t,e=Object.assign;return "function"==typeof e&&(t={foo:"raz"},e(t,{bar:"dwa"},{trzy:"trzy"}),t.foo+t.bar+t.trzy==="razdwatrzy")};},function(t,e,n){var r=n(10),o=n(14),i=Math.max;t.exports=function(t,e){var n,u,a,s=i(arguments.length,2);for(t=Object(o(t)),a=function(r){try{t[r]=e[r];}catch(t){n||(n=t);}},u=1;u<s;++u)e=arguments[u],r(e).forEach(a);if(void 0!==n)throw n;return t};},function(t,e,n){t.exports=function(t){return "function"==typeof t};},function(t,e,n){t.exports=n(11)()?Object.keys:n(12);},function(t,e,n){t.exports=function(){try{return Object.keys("primitive"),!0}catch(t){return !1}};},function(t,e,n){var r=n(0),o=Object.keys;t.exports=function(t){return o(r(t)?Object(t):t)};},function(t,e,n){var r=n(0),o=Array.prototype.forEach,i=Object.create,u=function(t,e){var n;for(n in t)e[n]=t[n];};t.exports=function(t){var e=i(null);return o.call(arguments,function(t){r(t)&&u(Object(t),e);}),e};},function(t,e,n){var r=n(0);t.exports=function(t){if(!r(t))throw new TypeError("Cannot use null or undefined");return t};},function(t,e,n){t.exports=n(16)()?String.prototype.contains:n(17);},function(t,e,n){var r="razdwatrzy";t.exports=function(){return "function"==typeof r.contains&&(!0===r.contains("dwa")&&!1===r.contains("foo"))};},function(t,e,n){var r=String.prototype.indexOf;t.exports=function(t){return r.call(this,t,arguments[1])>-1};},function(t,e,n){var r={object:!0,symbol:!0};t.exports=function(){var t;if("function"!=typeof Symbol)return !1;t=Symbol("test symbol");try{String(t);}catch(t){return !1}return !!r[typeof Symbol.iterator]&&(!!r[typeof Symbol.toPrimitive]&&!!r[typeof Symbol.toStringTag])};},function(t,e,n){t.exports=function(t){return !!t&&("symbol"==typeof t||!!t.constructor&&("Symbol"===t.constructor.name&&"Symbol"===t[t.constructor.toStringTag]))};},function(t,e,n){var r,o,i,u,a=n(4),s=n(21),c=Object.create,f=Object.defineProperties,l=Object.defineProperty,v=Object.prototype,d=c(null);if("function"==typeof Symbol){r=Symbol;try{String(r()),u=!0;}catch(t){}}var p=function(){var t=c(null);return function(e){for(var n,r,o=0;t[e+(o||"")];)++o;return e+=o||"",t[e]=!0,n="@@"+e,l(v,n,a.gs(null,function(t){r||(r=!0,l(this,n,a(t)),r=!1);})),n}}();i=function(t){if(this instanceof i)throw new TypeError("Symbol is not a constructor");return o(t)},t.exports=o=function t(e){var n;if(this instanceof t)throw new TypeError("Symbol is not a constructor");return u?r(e):(n=c(i.prototype),e=void 0===e?"":String(e),f(n,{__description__:a("",e),__name__:a("",p(e))}))},f(o,{for:a(function(t){return d[t]?d[t]:d[t]=o(String(t))}),keyFor:a(function(t){var e;s(t);for(e in d)if(d[e]===t)return e}),hasInstance:a("",r&&r.hasInstance||o("hasInstance")),isConcatSpreadable:a("",r&&r.isConcatSpreadable||o("isConcatSpreadable")),iterator:a("",r&&r.iterator||o("iterator")),match:a("",r&&r.match||o("match")),replace:a("",r&&r.replace||o("replace")),search:a("",r&&r.search||o("search")),species:a("",r&&r.species||o("species")),split:a("",r&&r.split||o("split")),toPrimitive:a("",r&&r.toPrimitive||o("toPrimitive")),toStringTag:a("",r&&r.toStringTag||o("toStringTag")),unscopables:a("",r&&r.unscopables||o("unscopables"))}),f(i.prototype,{constructor:a(o),toString:a("",function(){return this.__name__})}),f(o.prototype,{toString:a(function(){return "Symbol ("+s(this).__description__+")"}),valueOf:a(function(){return s(this)})}),l(o.prototype,o.toPrimitive,a("",function(){var t=s(this);return "symbol"==typeof t?t:t.toString()})),l(o.prototype,o.toStringTag,a("c","Symbol")),l(i.prototype,o.toStringTag,a("c",o.prototype[o.toStringTag])),l(i.prototype,o.toPrimitive,a("c",o.prototype[o.toPrimitive]));},function(t,e,n){var r=n(19);t.exports=function(t){if(!r(t))throw new TypeError(t+" is not a symbol");return t};}])});
//# sourceMappingURL=moment-range.js.map
});

unwrapExports(momentRange);
var momentRange_1 = momentRange.extendMoment;

var ARRIVALS_ONLY_LABEL = DateRangePickerConstants.ARRIVALS_ONLY_LABEL,
  CANCEL_BUTTON_LABEL = DateRangePickerConstants.CANCEL_BUTTON_LABEL,
  CHECK_IN_LABEL = DateRangePickerConstants.CHECK_IN_LABEL,
  CHECK_OUT_LABEL = DateRangePickerConstants.CHECK_OUT_LABEL,
  FLEXI_LABEL = DateRangePickerConstants.FLEXI_LABEL,
  DEPARTURE_ONLY_LABEL = DateRangePickerConstants.DEPARTURE_ONLY_LABEL,
  NO_ARRIVAL_TOOLTIP_LABEL = DateRangePickerConstants.NO_ARRIVAL_TOOLTIP_LABEL,
  NO_AVAILABILITY_LABEL = DateRangePickerConstants.NO_AVAILABILITY_LABEL,
  NO_AVAILABILITY_FOR_CHECKIN_LABEL = DateRangePickerConstants.NO_AVAILABILITY_FOR_CHECKIN_LABEL,
  FULLSCREEN_PORTAL_TITLE = DateRangePickerConstants.FULLSCREEN_PORTAL_TITLE,
  DONE_BUTTON_LABEL = DateRangePickerConstants.DONE_BUTTON_LABEL,
  NO_DEPARTURE_TOOLTIP_LABEL = DateRangePickerConstants.NO_DEPARTURE_TOOLTIP_LABEL,
  RESET_BUTTON_LABEL = DateRangePickerConstants.RESET_BUTTON_LABEL,
  TAX_INFO_LABEL = DateRangePickerConstants.TAX_INFO_LABEL,
  PRICE_QUALIFIER_LABEL = DateRangePickerConstants.PRICE_QUALIFIER_LABEL;
var moment = momentRange_1(moment$1);
PropTypes.shape({
  execute: PropTypes.func.isRequired
});
var transformToRange = function transformToRange(notAvailableDates) {
  return (notAvailableDates || []).map(function (range) {
    return {
      state: 'unavailable',
      range: moment.range(moment(range.from), moment(range.to))
    };
  });
};
var isFirstAvailableMonth = function isFirstAvailableMonth(startDate) {
  if (!startDate) {
    return true;
  }
  var today = moment().startOf('month');
  return moment(startDate).isSameOrBefore(today, 'month');
};
function DateRangeSelectorInputs(props) {
  var maxCheckOutDate = props.maxCheckOutDate,
    notAvailableDates = props.notAvailableDates,
    maxLengthOfStay = props.maxLengthOfStay,
    minLengthOfStay = props.minLengthOfStay,
    onChange = props.onChange,
    datesChanged = props.datesChanged,
    checkIn = props.checkIn,
    checkOut = props.checkOut,
    currentLanguage = props.currentLanguage,
    onDatePickingStateChange = props.onDatePickingStateChange,
    minNightOffset = props.minNightOffset,
    doneButtonLabel = props.doneButtonLabel,
    cancelButtonLabel = props.cancelButtonLabel,
    resetButtonLabel = props.resetButtonLabel,
    intl = props.intl,
    dayPrices = props.dayPrices,
    showInputs = props.showInputs,
    isAlwaysOpen = props.isAlwaysOpen,
    onNextMonthClick = props.onNextMonthClick,
    onPrevMonthClick = props.onPrevMonthClick,
    autoFocus = props.autoFocus,
    checkoutSummary = props.checkoutSummary,
    taxInfo = props.taxInfo,
    priceDisplayMode = props.priceDisplayMode,
    dateSelectMode = props.dateSelectMode,
    preventDateSelectionOnOutsideClick = props.preventDateSelectionOnOutsideClick,
    triggerChangeOnceEndDateSelected = props.triggerChangeOnceEndDateSelected,
    hidePriceCalendarOnSelect = props.hidePriceCalendarOnSelect,
    showPrice = props.showPrice,
    onCalendarOpenClose = props.onCalendarOpenClose,
    isCalendarOpen = props.isCalendarOpen,
    showCancelButton = props.showCancelButton,
    showResetButton = props.showResetButton,
    currencyDisplay = props.currencyDisplay,
    currencySymbol = props.currencySymbol,
    currencyCode = props.currencyCode,
    widthMode = props.widthMode,
    getContainerDimension = props.getContainerDimension,
    showBlockedDaysReferences = props.showBlockedDaysReferences,
    fullWidth = props.fullWidth,
    showInline = props.showInline,
    renderType = props.renderType;
  var _useState = useState(moment.locale(currentLanguage)),
    _useState2 = _slicedToArray(_useState, 2),
    locale = _useState2[0],
    setLocale = _useState2[1];
  var _useState3 = useState(transformToRange(notAvailableDates)),
    _useState4 = _slicedToArray(_useState3, 2),
    dateRanges = _useState4[0],
    setDateRanges = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    initialStartDate = _useState6[0],
    setInitialStartDate = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    initialEndDate = _useState8[0],
    setInitialEndDate = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    maxDate = _useState10[0],
    setMaxDate = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    firstDayOfWeek = _useState12[0],
    setFirstDayOfWeek = _useState12[1];
  var _useState13 = useState(isFirstAvailableMonth(checkIn)),
    _useState14 = _slicedToArray(_useState13, 2),
    hidePrevMonths = _useState14[0],
    setHidePrevMonths = _useState14[1];
  var interceptedOnPrevMonthClick = useCallback(function (month) {
    setHidePrevMonths(isFirstAvailableMonth(month));
    if (typeof onPrevMonthClick === 'function') {
      onPrevMonthClick(month);
    }
  }, [onPrevMonthClick]);
  var interceptedOnNextMonthClick = useCallback(function (month) {
    setHidePrevMonths(isFirstAvailableMonth(month));
    if (typeof onNextMonthClick === 'function') {
      onNextMonthClick(month);
    }
  }, [onNextMonthClick]);
  var nightsCountLabel = useCallback(function (nights) {
    return intl.formatMessage({
      id: 'bf.nightsCount',
      defaultMessage: 'bf.nightsCount'
    }, {
      count: nights
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    );
  }, [currentLanguage, intl]);
  var getMinLengthOfStayLabel = useCallback(function (los) {
    return intl.formatMessage({
      id: 'bf.minLosTooltip',
      defaultMessage: 'bf.minLosTooltip'
    }, {
      minLOS: nightsCountLabel(los)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    );
  }, [currentLanguage, intl, nightsCountLabel]);
  var getMaxLengthOfStayLabel = useCallback(function (los) {
    return intl.formatMessage({
      id: 'bf.maxLosTooltip',
      defaultMessage: 'bf.maxLosTooltip'
    }, {
      maxLOS: nightsCountLabel(los)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    );
  }, [currentLanguage, intl, nightsCountLabel]);
  var getPriceDisplayModeLabel = useCallback(function (priceDisplayMode) {
    switch (priceDisplayMode) {
      case 'perNight':
        return intl.formatMessage({
          id: 'bf.priceDisplayMode.avgPerNight',
          defaultMessage: 'bf.priceDisplayMode.avgPerNight'
        });
      case 'perPersonPerNight':
        return intl.formatMessage({
          id: 'bf.priceDisplayMode.avgPerPersonPerNight',
          defaultMessage: 'bf.priceDisplayMode.avgPerPersonPerNight'
        });
      case 'stay':
        return intl.formatMessage({
          id: 'bf.displayMode.totalPrice',
          defaultMessage: 'bf.displayMode.totalPrice'
        });
      default:
        return '';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLanguage, intl]);
  var minLosLabel = useCallback(function (minNights) {
    return intl.formatMessage({
      id: 'bf.minNights',
      defaultMessage: 'bf.minNights'
    }, {
      count: minNights
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    );
  }, [currentLanguage, intl]);
  var getTaxInfoLabel = useCallback(function (taxInfo) {
    switch (taxInfo) {
      case 'asInPricelist':
        return intl.formatMessage({
          id: 'bf.defaultPrice',
          defaultMessage: 'bf.defaultPrice'
        });
      case 'excludingTaxesAndFees':
        return intl.formatMessage({
          id: 'bf.excludingTaxesAndFees',
          defaultMessage: 'bf.excludingTaxesAndFees'
        });
      case 'withTaxesAndFees':
        return intl.formatMessage({
          id: 'bf.includingTaxesAndFeesExceptOnSite',
          defaultMessage: 'bf.includingTaxesAndFeesExceptOnSite'
        });
      case 'withInformativeTaxesAndFees':
        return intl.formatMessage({
          id: 'bf.includingTaxesAndFees',
          defaultMessage: 'bf.includingTaxesAndFees'
        });
      default:
        return '';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLanguage, intl]);
  var _useState15 = useState(CHECK_IN_LABEL),
    _useState16 = _slicedToArray(_useState15, 2),
    checkInLabel = _useState16[0],
    setCheckinLabel = _useState16[1];
  var _useState17 = useState(CHECK_OUT_LABEL),
    _useState18 = _slicedToArray(_useState17, 2),
    checkOutLabel = _useState18[0],
    setCheckoutLabel = _useState18[1];
  var _useState19 = useState(FLEXI_LABEL),
    _useState20 = _slicedToArray(_useState19, 2),
    flexiLabel = _useState20[0],
    setFlexiLabel = _useState20[1];
  var _useState21 = useState(FULLSCREEN_PORTAL_TITLE),
    _useState22 = _slicedToArray(_useState21, 2),
    fullScreenPortalTitle = _useState22[0],
    setFullScreenPortalTitle = _useState22[1];
  var _useState23 = useState(ARRIVALS_ONLY_LABEL),
    _useState24 = _slicedToArray(_useState23, 2),
    arrivalsOnlyLabel = _useState24[0],
    setArrivalsOnlyLabel = _useState24[1];
  var _useState25 = useState(DEPARTURE_ONLY_LABEL),
    _useState26 = _slicedToArray(_useState25, 2),
    departureOnlyLabel = _useState26[0],
    setDepartureOnlyLabel = _useState26[1];
  var _useState27 = useState(NO_AVAILABILITY_LABEL),
    _useState28 = _slicedToArray(_useState27, 2),
    noAvailabilityLabel = _useState28[0],
    setNoAvailabilityLabel = _useState28[1];
  var _useState29 = useState(NO_AVAILABILITY_FOR_CHECKIN_LABEL),
    _useState30 = _slicedToArray(_useState29, 2),
    noAvailabilityForCheckinLabel = _useState30[0],
    setNoAvailabilityForCheckinLabel = _useState30[1];
  var _useState31 = useState(NO_DEPARTURE_TOOLTIP_LABEL),
    _useState32 = _slicedToArray(_useState31, 2),
    noDepartureTooltipLabel = _useState32[0],
    setNoDepartureTooltipLabel = _useState32[1];
  var _useState33 = useState(NO_ARRIVAL_TOOLTIP_LABEL),
    _useState34 = _slicedToArray(_useState33, 2),
    noArrivalTooltipLabel = _useState34[0],
    setNoArrivalTooltipLabel = _useState34[1];
  var _useState35 = useState(TAX_INFO_LABEL),
    _useState36 = _slicedToArray(_useState35, 2),
    taxInfoLabel = _useState36[0],
    setTaxInfoLabel = _useState36[1];
  var _useState37 = useState(DONE_BUTTON_LABEL),
    _useState38 = _slicedToArray(_useState37, 2),
    _doneButtonLabel = _useState38[0],
    setDoneButtonLabel = _useState38[1];
  var _useState39 = useState(CANCEL_BUTTON_LABEL),
    _useState40 = _slicedToArray(_useState39, 2),
    _cancelButtonLabel = _useState40[0],
    setCancelButtonLabel = _useState40[1];
  var _useState41 = useState(RESET_BUTTON_LABEL),
    _useState42 = _slicedToArray(_useState41, 2),
    _resetButtonLabel = _useState42[0],
    setResetButtonLabel = _useState42[1];
  var _useState43 = useState(getMaxLengthOfStayLabel(maxLengthOfStay)),
    _useState44 = _slicedToArray(_useState43, 2),
    maxLosLabel = _useState44[0],
    setMaxLosLabel = _useState44[1];
  var _useState45 = useState(PRICE_QUALIFIER_LABEL),
    _useState46 = _slicedToArray(_useState45, 2),
    priceQualifier = _useState46[0],
    setPriceQualifier = _useState46[1];
  var _useState47 = useState(null),
    _useState48 = _slicedToArray(_useState47, 2),
    priceDisplayModeLabel = _useState48[0],
    setPriceDisplayModeLabel = _useState48[1];
  useEffect(function () {
    setMaxLosLabel(getMaxLengthOfStayLabel(maxLengthOfStay));
  }, [maxLengthOfStay, getMaxLengthOfStayLabel]);
  useEffect(function () {
    setCheckinLabel(intl.formatMessage({
      id: 'bf.checkIn',
      defaultMessage: 'bf.checkIn'
    }));
    setCheckoutLabel(intl.formatMessage({
      id: 'bf.checkOut',
      defaultMessage: 'bf.checkOut'
    }));
    setFlexiLabel(intl.formatMessage({
      id: 'bm.availability.bulk.update.dates',
      defaultMessage: 'bm.availability.bulk.update.dates'
    }));
    setFullScreenPortalTitle(intl.formatMessage({
      id: 'bf.stayDates',
      defaultMessage: 'bf.stayDates'
    }));
    setArrivalsOnlyLabel(intl.formatMessage({
      id: 'bf.arrivalsOnly',
      defaultMessage: 'bf.arrivalsOnly'
    }));
    setDepartureOnlyLabel(intl.formatMessage({
      id: 'bf.departuresOnly',
      defaultMessage: 'bf.departuresOnly'
    }));
    setNoAvailabilityLabel(intl.formatMessage({
      id: 'bf.noAvailability',
      defaultMessage: 'bf.noAvailability'
    }));
    setNoAvailabilityForCheckinLabel(intl.formatMessage({
      id: 'bf.noAvailabilityForCheckin',
      defaultMessage: 'bf.noAvailabilityForCheckin'
    }));
    setPriceQualifier(intl.formatMessage({
      id: 'bf.price.from',
      defaultMessage: 'bf.price.from'
    }));
    setNoDepartureTooltipLabel(intl.formatMessage({
      id: 'hotel.rateManager.ratePlans.addEditRatePlan.closeForDeparture.label',
      defaultMessage: 'hotel.rateManager.ratePlans.addEditRatePlan.closeForDeparture.label'
    }));
    setNoArrivalTooltipLabel(intl.formatMessage({
      id: 'hotel.rateManager.ratePlans.addEditRatePlan.closeForArrival.label',
      defaultMessage: 'hotel.rateManager.ratePlans.addEditRatePlan.closeForArrival.label'
    }));
    setDoneButtonLabel(intl.formatMessage({
      id: 'bf.doneButtonDatePicker',
      defaultMessage: 'bf.doneButtonDatePicker'
    }));
    setCancelButtonLabel(intl.formatMessage({
      id: 'bf.cancel',
      defaultMessage: 'bf.cancel'
    }));
    setResetButtonLabel(intl.formatMessage({
      id: 'seekda.chainmetacpc.reset',
      defaultMessage: 'seekda.chainmetacpc.reset'
    }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLanguage, intl]);
  useEffect(function () {
    setPriceDisplayModeLabel(getPriceDisplayModeLabel(priceDisplayMode));
  }, [priceDisplayMode, getPriceDisplayModeLabel]);
  useEffect(function () {
    setTaxInfoLabel(getTaxInfoLabel(taxInfo));
  }, [taxInfo, getTaxInfoLabel]);
  useEffect(function () {
    setLocale(moment.locale(currentLanguage));
    setFirstDayOfWeek(moment().localeData().firstDayOfWeek());
  }, [currentLanguage]);
  useEffect(function () {
    setDateRanges(notAvailableDates.map(function (range) {
      return {
        state: 'unavailable',
        range: moment.range(moment(range.from), moment(range.to))
      };
    }));
  }, [notAvailableDates]);
  useEffect(function () {
    setInitialStartDate(checkIn ? moment(checkIn, 'YYYY-MM-DD') : null);
  }, [checkIn]);
  useEffect(function () {
    setInitialEndDate(checkOut ? moment(checkOut, 'YYYY-MM-DD') : null);
  }, [checkOut]);
  useEffect(function () {
    setHidePrevMonths(isFirstAvailableMonth(initialStartDate));
  }, [initialStartDate]);
  useEffect(function () {
    setMaxDate(maxCheckOutDate ? moment(new Date(maxCheckOutDate)) : null);
  }, [maxCheckOutDate]);
  return /*#__PURE__*/React__default.createElement(DayPickerRangeControllerWrapper, {
    maxDate: maxDate,
    initialStartDate: initialStartDate,
    initialEndDate: initialEndDate,
    handleChange: onChange,
    datesChangeHandler: datesChanged,
    minLOS: minLengthOfStay,
    maxLOS: maxLengthOfStay,
    minNightOffset: minNightOffset,
    dateRanges: dateRanges,
    showInputs: showInputs,
    autoFocus: autoFocus,
    isAlwaysOpen: isAlwaysOpen,
    checkInLabel: checkInLabel,
    checkOutLabel: checkOutLabel,
    flexiLabel: flexiLabel,
    fullScreenPortalTitle: fullScreenPortalTitle,
    firstDayOfWeek: firstDayOfWeek,
    locale: locale,
    arrivalsOnlyLabel: arrivalsOnlyLabel,
    departureOnlyLabel: departureOnlyLabel,
    noAvailabilityLabel: noAvailabilityLabel,
    noAvailabilityForCheckinLabel: noAvailabilityForCheckinLabel,
    minLOSTooltipLabel: getMinLengthOfStayLabel,
    maxLOSTooltipLabel: maxLosLabel,
    noDepartureTooltipLabel: noDepartureTooltipLabel,
    noArrivalTooltipLabel: noArrivalTooltipLabel,
    getNightsCountLabel: nightsCountLabel,
    getMinLosLabel: minLosLabel,
    doneButtonLabel: doneButtonLabel ? doneButtonLabel : _doneButtonLabel,
    resetButtonLabel: resetButtonLabel ? resetButtonLabel : _resetButtonLabel,
    cancelButtonLabel: cancelButtonLabel ? cancelButtonLabel : _cancelButtonLabel,
    showResetButton: showResetButton,
    showCancelButton: showCancelButton,
    showPrice: showPrice,
    dayPrices: dayPrices,
    priceQualifier: priceQualifier,
    onNextMonthClick: interceptedOnNextMonthClick,
    onPrevMonthClick: interceptedOnPrevMonthClick,
    onDatePickingStateChange: onDatePickingStateChange,
    taxInfoLabel: taxInfoLabel,
    priceDisplayMode: priceDisplayModeLabel,
    dateSelectMode: dateSelectMode,
    preventDateSelectionOnOutsideClick: preventDateSelectionOnOutsideClick,
    triggerChangeOnceEndDateSelected: triggerChangeOnceEndDateSelected,
    hidePriceCalendarOnSelect: hidePriceCalendarOnSelect,
    onCalendarOpenClose: onCalendarOpenClose,
    isCalendarOpen: isCalendarOpen,
    hidePrevButton: hidePrevMonths,
    currencyDisplay: currencyDisplay,
    currencyCode: currencyCode,
    currencySymbol: currencySymbol,
    widthMode: widthMode,
    showInline: showInline,
    fullWidth: fullWidth,
    getContainerDimension: getContainerDimension,
    getCheckOutSummaryLabel: checkoutSummary,
    showBlockedDaysReferences: showBlockedDaysReferences,
    renderType: renderType
  });
}
DateRangeSelectorInputs.propTypes = {
  showBlockedDaysReferences: PropTypes.bool,
  autoFocus: PropTypes.bool,
  showInputs: PropTypes.bool,
  minLengthOfStay: PropTypes.number,
  maxLengthOfStay: PropTypes.number,
  hidePriceCalendarOnSelect: PropTypes.bool,
  showPrice: PropTypes.bool,
  showInline: PropTypes.bool,
  fullWidth: PropTypes.bool,
  isCalendarOpen: PropTypes.bool,
  showCancelButton: PropTypes.bool,
  showResetButton: PropTypes.bool,
  currencyDisplay: PropTypes.oneOf(['symbol', 'code']),
  currencyCode: PropTypes.string,
  currencySymbol: PropTypes.string,
  widthMode: PropTypes.oneOf(['CUSTOM_WIDTH', 'AUTO']),
  maxCheckOutDate: PropTypes.string,
  notAvailableDates: PropTypes.arrayOf(PropTypes.object),
  checkIn: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // string date or moment
  checkOut: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // string date or moment
  currentLanguage: PropTypes.string,
  minNightOffset: PropTypes.number,
  intl: PropTypes.shape(intlShape).isRequired,
  dayPrices: dayPricesShape,
  isAlwaysOpen: PropTypes.bool,
  taxInfo: PropTypes.string,
  priceDisplayMode: nodeOrStringProp,
  dateSelectMode: PropTypes.oneOf(['RESET_ON_RESELECT', 'ALTERNATING_CHECKIN_CHECKOUT_SELECT', 'NO_RESET']),
  preventDateSelectionOnOutsideClick: PropTypes.bool,
  triggerChangeOnceEndDateSelected: PropTypes.bool,
  renderType: PropTypes.string,
  // event handlers
  onCalendarOpenClose: PropTypes.func,
  onNextMonthClick: PropTypes.func,
  onPrevMonthClick: PropTypes.func,
  onChange: PropTypes.func,
  datesChanged: PropTypes.func,
  getContainerDimension: PropTypes.func,
  onDatePickingStateChange: PropTypes.func,
  // labels
  checkoutSummary: nodeOrStringOrFuncProp,
  doneButtonLabel: nodeOrStringOrFuncProp,
  cancelButtonLabel: nodeOrStringOrFuncProp,
  resetButtonLabel: nodeOrStringOrFuncProp
};
DateRangeSelectorInputs.defaultProps = {
  showBlockedDaysReferences: true,
  maxCheckOutDate: null,
  dayPrices: [],
  showInputs: false,
  isAlwaysOpen: false,
  autoFocus: false,
  preventDateSelectionOnOutsideClick: false,
  triggerChangeOnceEndDateSelected: false,
  hidePriceCalendarOnSelect: true,
  showPrice: false,
  showInline: false,
  fullWidth: false,
  isCalendarOpen: false,
  showCancelButton: true,
  showResetButton: true,
  currencyDisplay: 'code',
  currencyCode: '',
  currencySymbol: '',
  minLengthOfStay: 1,
  maxLengthOfStay: 0,
  notAvailableDates: [],
  checkIn: null,
  checkOut: null,
  currentLanguage: null,
  minNightOffset: 0,
  taxInfo: '',
  priceDisplayMode: '',
  dateSelectMode: 'ALTERNATING_CHECKIN_CHECKOUT_SELECT',
  renderType: 'default',
  // event handlers
  onCalendarOpenClose: function onCalendarOpenClose() {},
  onNextMonthClick: function onNextMonthClick() {},
  onPrevMonthClick: function onPrevMonthClick() {},
  onChange: function onChange() {},
  datesChanged: function datesChanged() {},
  getContainerDimension: function getContainerDimension() {},
  onDatePickingStateChange: function onDatePickingStateChange() {},
  // labels
  checkoutSummary: function checkoutSummary() {},
  doneButtonLabel: null,
  cancelButtonLabel: null,
  resetButtonLabel: null
};

export { DateRangeSelectorInputs as D };
//# sourceMappingURL=DateRangeSelectorInputs-fe536172.js.map
